const routes = [

  {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
    path: '',
    component: () => import('@/layouts/home-page/HomePage.vue'),
    children: [
      // =============================================================================
      // Theme Routes
      // =============================================================================
      {
          path: '/',
          name: 'Dashboard',
          component: () => import('../views/frontend/BookAppointment.vue'),
          meta: {
            roles: ['user']
          },
      },
      {
        path: '/:slug/direct/:staffslug',
        name: 'Book Appointment',
        component: () => import('../views/frontend/BookAppointment.vue'),
        meta: {
          roles: ['user']
        },
      },
      {
        path: '/:slug/book/:slot',
        name: 'Book Appointment',
        component: () => import('../views/frontend/BookAppointment.vue'),
        meta: {
          roles: ['user']
        },
      },
      {
        path: '/:slug',
        name: 'Book Appointment',
        component: () => import('../views/frontend/Appointment.vue'),
        meta: {
          roles: ['user']
        },
      },
      {
        path: '/:slug/direct/:staffslug/:reschedule',
        name: 'Reschedule Appointment',
        component: () => import('../views/frontend/BookAppointment.vue'),
        meta: {
          roles: ['user']
        },
      },
      {
        path: '/user/profile',
        name: 'Profile Update',
        component: () => import('../views/users/Profile'),
        meta: {
          roles: ['user']
        },
      }
    ],
  },

  //=============================================================================
  // FULL PAGE LAYOUTS
  // =============================================================================
  {
    path: '',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    children: [

      // =============================================================================
      // PAGES
      // =============================================================================
      {
        path: '/user/login',
        name: 'Login',
        component: () => import('@/views/users/auth/Login.vue')
      },
      {
        path: '/user/set-password/:token',
        name: 'Set Password',
        component: () => import('@/views/users/auth/Setpassword')
      },
      {
        path: '/user/forgot-password',
        name: 'Forgot Password',
        component: () => import('@/views/users/auth/ForgotPassword.vue')
      },
      {
        path: '/user/reset-password/:token',
        name: 'Reset Password',
        component: () => import('@/views/users/auth/ResetPassword')
      },
      {
        path: '/confhub/:room',
        name: 'conference',
        component: () => import('@/views/frontend/Conference'),
        meta: {
          roles: ['user']
        },
      },
    ],
  },
]

export default routes
